import es from '../locales/es/es.json';

export const translator = (word: string): string => es[word] || word;
